import { render } from "./cell_text.vue?vue&type=template&id=63a28ff7"
import script from "./cell_text.vue?vue&type=script&lang=ts"
export * from "./cell_text.vue?vue&type=script&lang=ts"

import "./cell_text.vue?vue&type=style&index=0&id=63a28ff7&lang=less"
script.render = render

export default script